import { render, staticRenderFns } from "./GlobalTip.vue?vue&type=template&id=2de8dcfc&scoped=true"
import script from "./GlobalTip.vue?vue&type=script&lang=js"
export * from "./GlobalTip.vue?vue&type=script&lang=js"
import style0 from "./GlobalTip.vue?vue&type=style&index=0&id=2de8dcfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8dcfc",
  null
  
)

export default component.exports